import { render } from "./SpanLayout.vue?vue&type=template&id=70d0e400&scoped=true&ts=true"
import script from "./SpanLayout.vue?vue&type=script&lang=ts"
export * from "./SpanLayout.vue?vue&type=script&lang=ts"

import "./SpanLayout.vue?vue&type=style&index=0&id=70d0e400&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d0e400"]])

export default __exports__